import React, { useState, useEffect } from 'react';
// import { Input } from '../../../../../Core/Fields/Floating/Input';
// import { DateField } from '../../../../../Core/Fields/Floating/Date';
import GetIcon from '../../../../../utils/Icon';
import VersionHistory from '../../../../../utils/VersionHistory';
import CollapsibleSection from '../../../../../Core/CollapsibleSection/CollapsibleSection';
import Input from '../../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../../Core/Fields/Floating/SelectSearch';
function Tab1({ genaralData, pTerms, price, currency, taxandchanges, project, cost_center, termandcondition }) {
    const [showActivity, setShowActivity] = useState(true);
    console.log(genaralData?.cost_center,"genaralData_came");
    
    const [fields, setFields] = useState({
        orderNo: '',
        date: '',
        customer: '',
        dueDate: '',
        order_type: '',
        billingType: '',
        currency: '',
        priceList: '',
        customerGroup: '',
        gstCategory: '',
        placeOfSupply: '',
        shippingAddress: '',
        company: '',
        status: '',
        deliveryStatus: '',
        billingStatus: ''
    });

    useEffect(() => {
        if (genaralData) {
            setFields({
                orderNo: genaralData.name || '',
                date: genaralData.transaction_date || '',
                customer: genaralData.customer_name || '',
                dueDate: genaralData.delivery_date || '',
                order_type: genaralData.order_type || '',
                billingType: genaralData.custom_billing_type || '',
                currency: genaralData.currency || '',
                priceList: genaralData.selling_price_list || '',
                customerGroup: genaralData.customer_group || '',
                gstCategory: genaralData.gst_category || '',
                placeOfSupply: genaralData.place_of_supply || '',
                shippingAddress: genaralData.shipping_address || '',
                company: genaralData.company || '',
                status: genaralData.status || '',
                deliveryStatus: genaralData.delivery_status || '',
                billingStatus: genaralData.billing_status || ''
            });
        }
    }, [genaralData]);

    return (
        <div className="row sidebarbox m-0" style={{ padding: "8px", borderRadius: "5px", height: "74vh", overflowY: "scroll" }}>
            {/* Top Section */}
            <div >
                <div className="d-flex gap-2 " style={{ marginBottom: '7px' }}>
                    <div className="col">
                        <Input
                            id="orderNo"
                            label="Order No"
                            value={fields.orderNo}
                            readOnly
                            style={{ height: '30px' }}
                        />
                    </div>
                    <div className="col">
                        <Input
                            id="date"
                            label="Order Date"
                            value={fields.date}
                            readOnly
                            style={{ height: '30px' }}
                        />
                    </div>
                </div>
                <div className='mb-3'>
                    <Input
                        id="customer"
                        label="Customer"
                        value={fields.customer}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>

                <div className='mb-3'>

                    <Input
                        id="dueDate"
                        label="Delivery Date"
                        value={fields.dueDate}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>

                <div className='mb-3'>

                    <Input
                        id="billingType"
                        label="Billing Type"
                        value={fields.billingType}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>
                <div className='mb-3' >

                    <Input
                        id="order_type"
                        label="Order Type"
                        value={fields.order_type}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>

            </div>

            <CollapsibleSection title="Accounting Dimensions">
                <div className="col-lg-12 mt-3 mb-3" >
                    {/* <div className={cost_center.Error ? `mb-3 errorborder` : `mb-3`}>
                        <SelectSearch
                            list={cost_center.list}
                            label="Cost Center"
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            value={genaralData?.cost_center}
                            onChange={(val) => cost_center.setvalue(val)}
                            disabled={true}
                          
                        />
                    </div> */}
                     <Input
                        id="costcenter"
                         label="Cost Center"
                        value={genaralData?.cost_center}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>
                <div className="col-lg-12 mt-3 mb-3" >
                    {/* <div className={project.Error ? `mb-3 errorborder` : `mb-3`}>
                        <SelectSearch
                            list={project.list}
                            label="Project"
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            value={genaralData?.project}
                            disabled={true}
                            onChange={(val) => project.setvalue(val)}
                        />
                    </div> */}

                      <Input
                        id="project"
                         label="Project"
                        value={genaralData?.project}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>
            </CollapsibleSection>
            <CollapsibleSection title="Payment Terms">
                <div className="col-lg-12 mt-3 mb-3" >
                    {/* <div className={pTerms.Error ? `mb-3 errorborder` : `mb-3`}>
                        <SelectSearch
                            list={pTerms.list}
                            label="Payment Terms Template"
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            value={genaralData?.payment_terms_template}
                            onChange={(val) => pTerms.setpaymentterm(val)}
                            disabled={true}
                        />
                    </div> */}
                      <Input
                        id="ptt"
                       label="Payment Terms Template"
                      value={genaralData?.payment_terms_template}
                        readOnly
                        style={{ height: '30px' }}
                    />
                </div>

            </CollapsibleSection>

            <CollapsibleSection title="Currency and Price List">
                <div className="col-lg-12 mt-3 mb-3" >

                       <Input
                        id="currency"
                       label="Currency"
                       value={genaralData?.currency}
                        readOnly
                        style={{ height: '30px' }}
                    />
                    {/* <div className={currency.Error ? `mb-3 errorborder` : `mb-3`}>
                        <SelectSearch
                            list={currency.list}
                            label="Currency"
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            value={genaralData?.currency}
                            disabled={true}
                            onChange={(val) => currency.setvalue(val)}
                        />
                    </div> */}
                </div>

                <div className="col-lg-12 mt-3 mb-3" >
                    
      
                     <Input
                        id="pricelist"
                       label="Price List"
                           value={genaralData?.selling_price_list}
                        readOnly
                        style={{ height: '30px' }}
                    />
                    {/* <div className={price.Error ? `mb-3 errorborder` : `mb-3`}>
                        <SelectSearch
                            list={price.list}
                            label="Price List"
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            value={genaralData?.selling_price_list}
                            onChange={(val) => price.setvalue(val)}
                            disabled={true}
                        />
                    </div> */}
                </div>
            </CollapsibleSection>

            {console.log("genaralDatagenaralData",genaralData)}
            <CollapsibleSection title="Taxes and Charges">
                <div className="col-lg-12 mt-3 mb-3" >
                     <Input
                        id="TaxesandCharges"
                        label="Taxes and Charges"
                         value={genaralData?.taxes_and_charges}
                        readOnly
                        style={{ height: '30px' }}
                    />
                    {/* <div className={taxandchanges.Error ? `mb-3 errorborder` : `mb-3`}>
                        <SelectSearch
                            list={taxandchanges.list}
                            label="Taxes and Charges"
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            value={genaralData?.taxes_and_charges}
                            onChange={(val) => taxandchanges.setvalue(val)}
                            disabled={true}

                        />
                    </div> */}
                </div>
            </CollapsibleSection>
            <CollapsibleSection title="Terms & Conditions">

                <div className="col-lg-12 mt-1 mb-3 pt-2" >

                     <Input
                        id="tandC"
                       label="Terms and Conditions"
                       value={genaralData?.tc_name}
                        readOnly
                        style={{ height: '30px' }}
                    />
                    {/* <div className={termandcondition.Error ? `mb-3 errorborder` : `mb-3`}>
                        <SelectSearch
                            list={termandcondition.list}
                            label="Terms and Conditions"
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            value={genaralData?.tc_name}
                            disabled={true}
                            onChange={(val) => termandcondition.settermsandcondition(val)}
                        />
                    </div> */}
                </div>

            </CollapsibleSection>
            <div style={{ height: "28vh" }}>


                <div className="col-12">
                    <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
                        <p className="firstcolor m-0">
                            Activity
                        </p>
                        <GetIcon
                            iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
                            size={22}
                        />
                    </div>

                    {showActivity && (
                        <VersionHistory
                            doctype="Sales Order"
                            docname={fields.orderNo}
                            activityboll={true}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Tab1;